module.exports = __webpack_public_path__ + "img/just_like_desktop.895fa757.png";